import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Card from 'components/Card';
import CommentInner from './Inner';

const CommentCard = ({ comment, onDelete, onLikeOrUnlike, viewer, style = {}, ...props }) => {
  const priority = useMemo(() => {
    return (comment.preferences || []).indexOf('PRIORITY') > -1;
  }, [comment.preferences]);
  return (
    <Card {...props} style={{ ...style, ...(priority ? {} : {}) }}>
      <CommentInner
        comment={comment}
        onDelete={onDelete}
        onLikeOrUnlike={onLikeOrUnlike}
        viewer={viewer}
        {...props}
      />
    </Card>
  );
};

CommentCard.propTypes = {
  comment: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  onLikeOrUnlike: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export default CommentCard;
//   CommentCard,
//   {
//     fragments: {
//       comment: () => Relay.QL`
//         fragment on Comment {
//           preferences
//           ${CommentInner.getFragment('comment')}
//         }
//       `,
//       viewer: () => Relay.QL`
//         fragment on Viewer {
//           ${CommentInner.getFragment('viewer')}
//         }
//       `,
//     },
//   },
// );
